

import ViewBase from '../../view-base.view';

export default function AnnouncementConfirmView() {
    ViewBase.call(this);
    return {
        view: (vnode) => {
            return [
                m('.row.md-12',
                    m('.card',
                        m('.card-body',
                       m('.col-md-12',m('label',this.getText("EM00000156", "Do you want to change the status?")))
                        ))),
                , this.getBaseViews()];
        }
    }
}
